<template>
  <div>
    <div>
      
      <font style="color: red;" v-if="tb.ismust">*</font>
      <font style="color: red;" v-else="tb.ismust">&nbsp </font>
      {{tb.name}}
    </div>

    <div :style="'color:'+(tb.secondcolor?tb.secondcolor:'#ddd')">
      {{tb.secondname?tb.secondname:''}}
    </div>


    <div v-if="tb.csstype&&tb.csstype=='a'">
      <div class=" weui-cells_checkbox" style="display: flex;flex-wrap: wrap;">
        <div v-for="(item,key) in tb.boxdata" :style="'width:'+1/tb.csstypenum*100+'%'" style="display: flex;align-items: center;">
          <label class="weui-cell weui-check__label noxiaoguo" :for="tv+tb.name+key"
           style="display:flex;flex-direction: column;align-content: left;width: 95%; margin-top: 5px;" :style="tb.border?'border: solid 1px #dddddd;':''">
            <img  class="weui-cell__hd"  v-if="tb.pic" :src="tb.pic?tb.pic[key].data:''"  alt="" style="width: 100%;">
            <label  class=" weui-check__label noxiaoguo" style="display: flex;align-items: center;width: 100%;">
            <div  class="weui-cell__hd" style="padding-right: 0px">
              <input class="weui-form-checkbox" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item"
                type="checkbox">
              <i class="weui-icon-checkbox"  style="border:solid 1px #dddddd" 
              :style="{backgroundColor:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}"
              ></i>
              
            </div>
            <div style="padding-left:0;padding-right: 0;" v-text="item" class="weui-cell__bd" :style="{color:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}">
            </div>   
          </label>     
          </label>
        </div>        
      </div>      
    </div>
    


    <!-- <div v-if="tb.csstype&&tb.csstype=='a'">
      <div class=" weui-cells_checkbox" style="display: flex;flex-wrap: wrap;">
        <div v-for="(item,key) in tb.boxdata" :style="'width:'+1/tb.csstypenum*100+'%'" style="display: flex;align-items: center;">
          <label class="weui-cell weui-check__label noxiaoguo" :for="tv+tb.name+key" style="display:flex;align-items: center;">
            <img src="/static/4.png" alt="" style="width: 100%;">
            <div  class="weui-cell__hd" style="padding-right: 0px">
              <input class="weui-form-checkbox" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item"
                type="checkbox">
              <i class="weui-icon-checkbox"  style="border:solid 1px #dddddd" 
              :style="{backgroundColor:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}"
              ></i>
              
            </div>
            <div style="padding-left:0;padding-right: 0;" v-text="item" class="weui-cell__bd" :style="{color:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}">
            </div>        
          </label>
        </div>        
      </div>      
    </div> -->






    <div class="weui-cells_checkbox" v-else>
      <template v-for="(item,key) in tb.boxdata">
        <label class="weui-cell weui-check__label noxiaoguo" :for="tv+tb.name+key" :style="(tb.border?'border: solid 1px #dddddd;;':'')+'margin-top: 5px;'"> 
          <img  v-if="tb.pic" :src="tb.pic?tb.pic[key].data:''"  alt="" style="width: 15%;"> 
          <div class="weui-cell__hd">
            <input class="weui-form-checkbox" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item"
              type="checkbox">
            <i class="weui-icon-checkbox"  style="border:solid 1px #dddddd" 
            :style="{backgroundColor:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}"></i>
          </div>

          <div v-text="item" class="weui-cell__bd" :style="{color:picked.includes(item)?(globalsetting.checkcolor?globalsetting.checkcolor:'green'):''}">
          </div>
        </label>
      </template>
    </div>

<!--    
    <div class="weui-cells_checkbox" v-else>
      <template v-for="(item,key) in tb.boxdata">
        <label class="weui-cell weui-check__label noxiaoguo" :for="tv+tb.name+key">

          <div class="weui-cell__hd">
            <input class="weui-form-checkbox" :name="tv+tb.name" :id="tv+tb.name+key" v-model='picked' :value="item"
              type="checkbox">
            <i class="weui-icon-checkbox"></i>
          </div>

          <div v-text="item" class="weui-cell__bd" :style="{color:picked.indexOf(item)!=-1?'green':''}">
          </div>
        </label>
      </template>
    </div> -->

  </div>
</template>

<script>

  export default {
    props: ['tb', 'tv','globalsetting'],
    name: 'CheckBox',
    data() {
      return {       
        picked: [],
      }
    },

    watch: {
      picked(n, o) {

        this.tb.val = this.picked.join(',');
      }
    },
    computed: {
      all() {
        let nam = this.listname;
        let obj = {};
        obj["你最喜欢的类型"] = this.picked.join(",")
        return obj;
      }
    }
  }

</script>

<style scoped>
  input[type="checkbox"] {
    visibility: hidden;
  }

  .bdlay {
    flex: 1;
    background-color: red;
    pointer-events: none;
  }

  .weui-icon-checkbox {

    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    margin-top: 6px;
    margin-right: 5px;
    border: 1px solid #b8b8b8;
    background-color: #fafafa;
    vertical-align: top;
    cursor: pointer;
  }

  .weui-form-checkbox[type="checkbox"]:checked+.weui-icon-checkbox {

    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY0MTI1RkFBQjJCNzExRTU5NzE3RDMyNDM3NTgzRTE4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY0MTI1RkFCQjJCNzExRTU5NzE3RDMyNDM3NTgzRTE4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjQxMjVGQThCMkI3MTFFNTk3MTdEMzI0Mzc1ODNFMTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjQxMjVGQTlCMkI3MTFFNTk3MTdEMzI0Mzc1ODNFMTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5UDJTUAAABUElEQVR42mL8//8/w0ACJoYBBqMOGHEOsB0oB/AC8UIgPgTEZvR2gDYQnwXiOChfH0UWVA7QEPsA8af/CDAJXQ0tLS8G4r9Ili8BYkZ6OaD9Pyo4AcQc2NRS22ImIJ6OZvltIBbFpYealjMD8WI0y78CsS4+fdS0fNl/TBBOSC8uCVBiyQViASItX4HF8j5iHI/LwIVQQ+4CsQEeA1iAeBUWyw9AzSHLAS1ohn0H4hQs6liBeDUWy58AsTix0YdNUBiIz2AxeD4Qc0HVsAHxOixqfgKxNSnpB5cEPxAfw2LBeWiq3vofO8gjNQHjk+QF4kNYLPmHw/Kl5OQgQgpAQb77P2FwDil6qOoABmgRuhWP5a+AWJbcMoRYhaBEtx5HorOjpBAjRTEo261Ec0AKpaUoOUUurJDqpEYxTm6Nl05sSUcIM472jEYdMOIdABBgAFfZNpPCdKCTAAAAAElFTkSuQmCC");
    background-size: 100%;
    background-color: #07c160;
    border: 1px solid #07c160;
    cursor: pointer;
  }
  .noxiaoguo:active{
  background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/fields/CheckBox.vue